var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2418_1700)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.3333 4H2.66665C2.31302 4 1.97389 4.14048 1.72384 4.39052C1.47379 4.64057 1.33331 4.97971 1.33331 5.33333V18.6667C1.33331 19.0203 1.47379 19.3594 1.72384 19.6095C1.97389 19.8595 2.31302 20 2.66665 20H21.3333C21.6869 20 22.0261 19.8595 22.2761 19.6095C22.5262 19.3594 22.6666 19.0203 22.6666 18.6667V5.33333C22.6666 4.97971 22.5262 4.64057 22.2761 4.39052C22.0261 4.14048 21.6869 4 21.3333 4ZM20.3066 18.6667H3.77331L8.43998 13.84L7.47998 12.9133L2.66665 17.8933V6.34667L10.9533 14.5933C11.2031 14.8417 11.5411 14.9811 11.8933 14.9811C12.2456 14.9811 12.5835 14.8417 12.8333 14.5933L21.3333 6.14V17.8067L16.4266 12.9L15.4866 13.84L20.3066 18.6667ZM3.53998 5.33333H20.2533L11.8933 13.6467L3.53998 5.33333Z",
    fill: "#673C8E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2418_1700"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.092d617c23c27f74cfb6ad8c41209460.svg";
export { ForwardRef as ReactComponent };